import Navigation from "../layouts/NavigationDrawer/Index";
import contabilizar from "../modules/nfe/contabilizar/routes/index";
import empresaCentroCusto from "../modules/nfe/empresaCentrosCusto/routes/index";
import empresas from "../modules/nfe/empresas/routes/index";
import bloqueioNotas from "../modules/rpa/bloqueioNotas/routes/index";
import bloqueioPecas from "../modules/rpa/bloqueioPecas/routes/index";
import bloqueioPrefeituras from "../modules/rpa/bloqueioPrefeituras/routes/index";
import descontos from "../modules/rpa/descontos/routes/index";
import despesaCnpj from "../modules/rpa/despesaCnpj/routes/index";
import gruposEmail from "../modules/rpa/gruposEmail/routes/index";
import layout from "../modules/rpa/layouts/routes/index";
import senhas from "../modules/rpa/senhas/routes/index";
import unidadesConsumidoras from '../modules/rpa/unidadesConsumidoras/routes/index';
import mensagensLua from '../modules/rpa/mensagensLua/routes/index';
import servicosPrestados from "../modules/rpa/servicosPrestados/routes/index";
import CodigoServicoG4 from "../modules/rpa/codigoServicoG4/routes/index";
export default [
  {
    path: "/",
    name: "Home",
    component: Navigation,
    meta: { requiresAuth: true },
    children: [
      ...empresas,
      ...bloqueioPrefeituras,
      ...bloqueioNotas,
      ...CodigoServicoG4,
      ...contabilizar,
      ...descontos,
      ...despesaCnpj,
      ...gruposEmail,
      ...layout,
      ...senhas,
      ...servicosPrestados,
      ...empresaCentroCusto,
      ...bloqueioPecas,
      ...unidadesConsumidoras,
      ...mensagensLua,
    ],
  },
];
